/* eslint-disable react/destructuring-assignment */
import { AnswerContent } from './answer-content';
import { Header } from './header';
import { ReportContext } from './hooks/use-context';
import { ImagesGrid } from './images-grid';
import { ItemsList } from './items-list';
import { QuestionList } from './question-list';
import { SectionsList } from './sections-list';
import type { EventReportData } from './types';

export function MichelinfleetReport(props: { reportData: EventReportData }) {
  return (
    <ReportContext value={props.reportData}>
      <div>
        <div className="h-[90%] w-screen flex-1 bg-white font-sans">
          <div className="mx-auto h-auto max-w-4xl">
            <Header />
            <ItemsList>
              <SectionsList>
                <QuestionList>
                  <AnswerContent />
                </QuestionList>
              </SectionsList>
            </ItemsList>
            <ImagesGrid />
          </div>
        </div>
      </div>
    </ReportContext>
  );
}
